import jwtDecode from 'jwt-decode';
import { recursiveFreeze } from '@philips-internal/oswald-ui-utils';
const TYPE = Symbol('type');
const JWT_TOKEN = Symbol('jwtToken');
const RAW_TOKEN = Symbol('raw-token');
const PAYLOAD = Symbol('payload');
class JWTToken {
    constructor(type, jwtToken, rawToken) {
        // @ts-ignore: library's package.json is wrongly configured
        const token = jwtDecode(jwtToken);
        this[TYPE] = type;
        this[JWT_TOKEN] = jwtToken;
        this[RAW_TOKEN] = rawToken;
        this[PAYLOAD] = recursiveFreeze(token);
    }
    get subject() {
        return this.claims.sub;
    }
    get issuer() {
        return this.claims.iss;
    }
    get expiration() {
        return this.claims.exp;
    }
    get issuedAt() {
        return this.claims.iat;
    }
    get audience() {
        return this.claims.aud;
    }
    get claims() {
        return this[PAYLOAD];
    }
    get roles() {
        return this.claims.roles;
    }
    get permissions() {
        return this.claims.permissions;
    }
    getType() {
        return this[TYPE];
    }
    rawToken() {
        return this[RAW_TOKEN];
    }
}
export { JWTToken, };
//# sourceMappingURL=JWTToken.js.map